import type {
    OrganizationCapacityFilter,
    OrganizationCapacityKey,
    OrganizationListItem,
} from '@pillar-portal/api-types';

type OrganizationCapacityFields = Pick<OrganizationListItem, OrganizationCapacityKey>;

const ORGANIZATION_CAPACITY_KEYS: ReadonlyArray<OrganizationCapacityKey> = [
    'is_iso',
    'is_merchant',
    'is_customer',
];

const ORGANIZATION_CAPACITY_LABELS: Readonly<Record<OrganizationCapacityKey, string>> = {
    is_iso: 'ISO',
    is_merchant: 'MERCHANT',
    is_customer: 'CUSTOMER',
};

export function organizationHasCapacity(
    organization: OrganizationCapacityFields,
    capacityKey: OrganizationCapacityKey
): boolean {
    return organization[capacityKey] === true;
}

export function getOrganizationCapacityDisplayName(capacityKey: OrganizationCapacityKey): string {
    return ORGANIZATION_CAPACITY_LABELS[capacityKey];
}

export function getOrganizationCapacityFilter(
    capacityKey: OrganizationCapacityKey
): OrganizationCapacityFilter {
    switch (capacityKey) {
        case 'is_iso':
            return { is_iso: true };
        case 'is_merchant':
            return { is_merchant: true };
        case 'is_customer':
            return { is_customer: true };
    }
}

export function getOrganizationCapacityLabel(organization: OrganizationCapacityFields): string {
    const capacities: string[] = ORGANIZATION_CAPACITY_KEYS.filter((capacityKey) =>
        organizationHasCapacity(organization, capacityKey)
    ).map(getOrganizationCapacityDisplayName);

    return capacities.length > 0 ? capacities.join(', ') : 'NONE';
}
